// extracted by mini-css-extract-plugin
module.exports = {"list":"_17hV2m0_IuUPLNazBT1--W","item":"_3vf7wOCaagVNf3dZc3is8v"};